import axios from 'axios';

export default {

    //Permet de récuperer la liste des collaborateurs d'un utilisateur
    get(userId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/collaborator/list/'+userId);
    },

    //Ajoute un nouveau collaborateur
    post(collaboratorData) {
        return axios.post(process.env.VUE_APP_API_URI + '/api/collaborator', collaboratorData);
    },

    //Modifie un collaborateur
    patch(collaboratorId, collaboratorData) {
        return axios.patch(process.env.VUE_APP_API_URI + '/api/collaborator/' + collaboratorId, collaboratorData);
    },

    //Supprime un collaborateur
    remove(collaboratorId) {
        return axios.delete(process.env.VUE_APP_API_URI + '/api/collaborator/' + collaboratorId);
    },

}
